import { render, staticRenderFns } from "./ImportForms.vue?vue&type=template&id=5e667262&scoped=true&"
import script from "./ImportForms.vue?vue&type=script&lang=js&"
export * from "./ImportForms.vue?vue&type=script&lang=js&"
import style0 from "./ImportForms.vue?vue&type=style&index=0&id=5e667262&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e667262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5e667262')) {
      api.createRecord('5e667262', component.options)
    } else {
      api.reload('5e667262', component.options)
    }
    module.hot.accept("./ImportForms.vue?vue&type=template&id=5e667262&scoped=true&", function () {
      api.rerender('5e667262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/pages/tools/ImportForms.vue"
export default component.exports